module.exports = __webpack_public_path__ + "img/calendar_menu.786ed98b.svg";